import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OfferScope } from '../../types';
import { TalentPoolsHttpService } from './talent-pools-http.service';
import { TalentPoolItemsActions } from './talent-pools.store';

@Injectable({
  providedIn: 'root',
})
export class TalentPoolsEffects {
  public effects = createEffectFactory(TalentPoolItemsActions, this.actions$);

  public fetchActiveCollection$ = this.effects(TalentPoolItemsActions.fetchActiveCollection, () =>
    of(TalentPoolItemsActions.fetchCollection({ payload: { scope: OfferScope.Active } })),
  );

  public fetchArchivedCollection$ = this.effects(
    TalentPoolItemsActions.fetchArchivedCollection,
    () => of(TalentPoolItemsActions.fetchCollection({ payload: { scope: OfferScope.Archived } })),
  );

  public fetchCollection$ = this.effects(TalentPoolItemsActions.fetchCollection, ({ payload }) =>
    this.talentPoolsHttpService.fetchCollection$(payload!.scope).pipe(
      map(response => ({
        data: response.offers,
        scope: payload!.scope,
      })),
    ),
  );

  public remove$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TalentPoolItemsActions.removeOnePessimistic),
      mergeMap(({ payload }) =>
        this.talentPoolsHttpService.delete$({ id: <number>payload.data }).pipe(
          switchMap(response => [
            TalentPoolItemsActions.removeOnePessimisticSuccess({
              payload: { data: response.offer },
            }),
          ]),
          catchError(error =>
            of(
              TalentPoolItemsActions.removeOnePessimisticFailed({
                payload: { error, data: payload.data },
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public updatePositions$ = this.effects(TalentPoolItemsActions.updatePositions, ({ payload }) =>
    this.talentPoolsHttpService.updatePositions$({ positions: payload }).pipe(
      switchMap(response =>
        of(TalentPoolItemsActions.updatePositionSuccess({ payload: response })),
      ),
      catchError(error => of(TalentPoolItemsActions.updatePositionsFailed({ payload: { error } }))),
    ),
  );

  constructor(
    private talentPoolsHttpService: TalentPoolsHttpService,
    private actions$: Actions,
  ) {}
}
